const NAME = "ATTENDANCE_REPORT";

export default NAME;
